<div>
  <mat-toolbar color="accent">
    <mat-toolbar-row>
      <button mat-button (click)="onRefresh()">
        <mat-icon aria-hidden="false" aria-label="Refresh">refresh</mat-icon>
        Refresh Customer Sites
      </button>
      <button mat-button (click)="onAdd()">
        <mat-icon aria-hidden="false" aria-label="Add Customer Site">add</mat-icon>
        Add Customer Site
      </button>
      <span class="toolbar-spacer"></span>
      <mat-form-field color="accent">
        <input
          matInput
          placeholder="Search customer sites..."
          [(ngModel)]="filter"
          (ngModelChange)="onFilter($event)"
        />
      </mat-form-field>
      <button mat-icon-button aria-label="Clear" *ngIf="filter" (click)="onFilter('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <ng-container *ngIf="loading; else loaded">
    <div class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Loading Customer Sites...</p>
    </div>
  </ng-container>
  <ng-template #loaded>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort width="100%">
      <ng-container matColumnDef="siteCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Site Code</th>
        <td mat-cell *matCellDef="let item">{{ item.siteCode }}</td>
      </ng-container>
      <ng-container matColumnDef="siteName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Site Name</th>
        <td mat-cell *matCellDef="let item">{{ item.siteName }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item" class="actions-cell">
          <button mat-flat-button color="accent" [routerLink]="['/admin/customer-sites', item.siteCode]">Edit</button>
          <button mat-flat-button color="warn" (click)="onDelete(item)">Delete</button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    </table>
  </ng-template>
</div>
